// Öffentliche App-Config (Shop-URL, Credit-Preise) — einmal fetchen, cachen.
// Quelle: GET /config/public (ohne Auth, Backend app/routes/config.py).

import { useEffect, useState } from "react";

import { api, type PublicConfig } from "@/api/client";

let cache: PublicConfig | null = null;
let inflight: Promise<PublicConfig | null> | null = null;

export function loadPublicConfig(): Promise<PublicConfig | null> {
  if (cache) return Promise.resolve(cache);
  inflight ??= api
      .publicConfig()
      .then((cfg) => (cache = cfg))
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  return inflight;
}

export function usePublicConfig(): PublicConfig | null {
  const [cfg, setCfg] = useState<PublicConfig | null>(cache);
  useEffect(() => {
    let live = true;
    loadPublicConfig().then((c) => {
      if (live) setCfg(c);
    });
    return () => {
      live = false;
    };
  }, []);
  return cfg;
}
